// extracted by mini-css-extract-plugin
module.exports = {"Kiosk":"Kiosk_Kiosk__3cR_V","AdminLoginButton":"Kiosk_AdminLoginButton__t7wfr","Link":"Kiosk_Link__2J4Ml","ContactCard":"Kiosk_ContactCard__1d8fb"};